import { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

import DownImage from '../../image/down.png';
import UpImage from '../../image/up.png';

const ReserveOpenCountInput = forwardRef((_, ref) => {
  const { t } = useLanguage();

  const [dateVal, setDateVal] = useState(0);
  const [time, setTime] = useState('');

  const InputRef = useRef();
  const TimeInputRef = useRef();

  useImperativeHandle(ref, () => ({
    setValue: (val) => {
      setDateVal(val);
    },
    setUnit: () => {
    },
    getValue: () => {
      let multiplier = 60 * 24;
      return (dateVal * multiplier);
    },
    getUnit: () => {
      return '일';
    },
    setTime: (val) => {
      if (val === undefined || val.length < 5) setTime('00:00');
      else setTime(val);
    },
    getTime: () => {
      return time === '' ? '00:00' : time;
    }
  }))

  // 입력값 변경시 //
  function onChangeInput(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");
    setDateVal(result === '' ? 0 : parseInt(result));
  }

  // 증가 버튼 클릭시 //
  function onClickUp() {
    setDateVal(dateVal + 1);
  }

  // 감소 버튼 클릭시 //
  function onClickDown() {
    if (dateVal > 0) setDateVal(dateVal - 1);
  }

  // 오픈시간 변경시 //
  function onChangeTime(e) {
    if (e.target.value.length > 5) return;

    const regex = /^[0-9:\-\b]{0,11}$/;

    if (regex.test(e.target.value)) {
      if (e.target.value.length === 2) setTime(e.target.value.replace(/(\d{2})/, '$1:'));
      else if (e.target.value.length === 5) setTime(e.target.value.replace(/(\d{2}):(\d{2})/, '$1:$2'))
      else setTime(e.target.value);
    }
  }

  // 오픈시간 포커스시 //
  function onFocusTime() {
    setTime('');
  }

  // 오픈시간 키다운시 //
  function onKeyDownTime(e) {
    if (e.key === 'Backspace') {
      if (time.length === 3 || time.length === 6 || time.length === 9) {
        setTime(time.substring(0, time.length - 1));
      }
    }
  }

  return (
    <TopLevelWrapper>
      <TopWrapper>
        <LeftWrapper>
          <Input
            ref={InputRef}
            placeholder={0}
            value={dateVal}
            onChange={onChangeInput} />
          <ButtonWrapper>
            <Button img={UpImage} onClick={onClickUp} />
            <Button img={DownImage} onClick={onClickDown} />
          </ButtonWrapper>
        </LeftWrapper>
        <Text
          fontFamily='NotoSansKR-Regular'
          fontSize={12}
          color='#CBCBCB'>
          {t('system.day')}
        </Text>
        <TimeInput
          ref={TimeInputRef}
          placeholder='00:00'
          value={time}
          onKeyDown={onKeyDownTime}
          onChange={onChangeTime}
          onFocus={onFocusTime} />
      </TopWrapper>
      <Text
        style={{ marginTop: '6px' }}
        fontFamily='NotoSansKR-Regular'
        fontSize={12}
        color='#FF8B48'>
        {t('system.bookingOpenHint', { days: dateVal, time: time === '' ? '00:00' : time })}
      </Text>
    </TopLevelWrapper>
  )
})

export default ReserveOpenCountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 8px;

  transition: all 0.3s ease-in-out;
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 53px;
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background-color: #FFFFFF;

  padding: 0 8px 0 8px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  ::placeholder {
    color: #CBCBCB;
  }
`;

const TimeInput = styled.input`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 39px;
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background-color: #FFFFFF;

  padding: 0 19px 0 19px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  ::placeholder {
    color: #CBCBCB;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background: url(${props => props.img}) no-repeat center;
  background-color: #ECECEC;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
